import { bool, number, node, object, func, arrayOf, string, oneOfType } from "prop-types";
import { observer } from "mobx-react";
import { BreakdownTableDepths } from "@repo/utils";
import { SortableList } from "@components";
import { TimelineNestedRow } from "../TimelineNestedRow/TimelineNestedRow";
import { TimelineRowGroup } from "../TimelineRowGroup/TimelineRowGroup";

export const TimelineRowGroupList = observer(({
  disabled,
  isLastGroupRow,
  listElements,
  onReorder,
  children,
  hashedPath,
  tableDepth = BreakdownTableDepths.SECTION,
  ...otherProps
}) => (
  <>
    <SortableList
      list={listElements}
      path={hashedPath.join("/")}
      group={hashedPath.join("/")}
      onListReorder={onReorder}
      displayAsColumnFlexbox
      disabled={disabled}
    >
      {listElements?.map((child, i) =>
        tableDepth ? (
          <TimelineNestedRow
            key={`element${child.id}`}
            resource={child}
            isLastGroupRow={isLastGroupRow && i === listElements.length - 1}
            tableDepth={tableDepth + 1}
            {...otherProps}
          />
        ) : (
          <TimelineRowGroup
            key={`element${child.id}`}
            workType={child}
            tableDepth={tableDepth + 1}
            {...otherProps}
          />
        )
      )}
    </SortableList>
    {children}
  </>
));

TimelineRowGroupList.propTypes = {
  tableDepth: number,
  listElements: arrayOf(object),
  onReorder: func,
  isLastGroupRow: bool,
  
  hashedPath: arrayOf(oneOfType([number, string])),
  children: node,
  disabled: bool,
};
